import Vue from 'vue'
import Router from 'vue-router'
import store from '../utils/store'

const requireComponent = require.context("@/views", true, /routes\.js$/);
let routes = [];
requireComponent.keys().forEach(filePath => {
  const componentConfig = requireComponent(filePath);
  routes = [...routes, ...componentConfig.default]
});

Vue.use(Router);
const myComponents = {
  Launch: r => require.ensure([], () => r(require('@/components/home/Launch')), 'com-launch'),
  Home: r => require.ensure([], () => r(require('@/components/home/Home.vue')), 'com-index'),
  Account: r => require.ensure([], () => r(require('@/components/account/Account')), 'com-account'),
  Advance: r => require.ensure([], () => r(require('@/components/advance/Advance')), 'com-advance'),
  AdvanceRecord: r => require.ensure([], () => r(require('@/components/advance/AdvanceRecord')), 'com-advance-record'),
  My: r => require.ensure([], () => r(require('@/components/my/My')), 'com-my'),
  Login: r => require.ensure([], () => r(require('@/components/login/Login')), 'com-login'),
  Cash: r => require.ensure([], () => r(require('@/components/cash/Cash')), 'com-cash'),
  SupplementCard: r => require.ensure([], () => r(require('@/components/cash/SupplementCard')), 'supplement-card'),
  CashAlipay: r => require.ensure([], () => r(require('@/components/cash/CashAlipay')), 'cash-alipay'),
  CashForShare: r => require.ensure([], () => r(require('@/components/cash/CashForShare')), 'com-cash-share'),
  CashForRedPack: r => require.ensure([], () => r(require('@/components/cash/CashForRedPack')), 'com-cash-redpack'),
  CashAll: r => require.ensure([], () => r(require('@/components/cash/CashAll')), 'com-cash-all'),
  RedPackPage: r => require.ensure([], () => r(require('@/components/redpackPage/index')), 'com-redpack-page'),
  BindAlipay: r => require.ensure([], () => r(require('@/components/alipay/BindAlipay')), 'com-bind-alipay'),
  SlowBank: r => require.ensure([], () => r(require('@/components/card/slowBank')), 'com-slow-bank'),
  Detailed: r => require.ensure([], () => r(require('@/components/account/Detailed')), 'com-detailed'),
  AccountDetails: r => require.ensure([], () => r(require('@/components/account/AccountDetails')), 'com-account-details'),
  Card: r => require.ensure([], () => r(require('@/components/card/Card')), 'com-card'),
  BindCard: r => require.ensure([], () => r(require('@/components/card/bindCard')), 'com-bind-card'),
  LoginVertify: r => require.ensure([], () => r(require('@/components/login/LoginVertify')), 'com-vertify-login'),
  Serve: r => require.ensure([], () => r(require('@/components/my/Serve')), 'com-bind-serve'),
  Apply: r => require.ensure([], () => r(require('@/components/advance/Apply')), 'com-apply'),
  ApplySure: r => require.ensure([], () => r(require('@/components/advance/ApplySure')), 'com-sure'),
  ApplySuccess: r => require.ensure([], () => r(require('@/components/advance/ApplySuccess')), 'com-success'),
  About: r => require.ensure([], () => r(require('@/components/my/about')), 'com-about'),
  BindAll: r => require.ensure([], () => r(require('@/components/bind/bindAll')), 'com-bind-all'),
  CardDetail: r => require.ensure([], () => r(require('@/components/card/CardDetail')), 'com-card-detail'),
  AgreementList: r => require.ensure([], () => r(require('@/components/cash/AgreementList')), 'com-cash-agreement-list'),
  Daily: r => require.ensure([], () => r(require('@/components/daily/daily')), 'com-daily'),
  DailyRecord: r => require.ensure([], () => r(require('@/components/daily/dailyRecord')), 'com-daily-record'),
  DailyCalendar: r => require.ensure([], () => r(require('@/components/daily/dailyCalendar')), 'com-daily-calendar'),
  DailyFail: r => require.ensure([], () => r(require('@/components/daily/fail')), 'com-daily-fail'),
  WageSlip: r => require.ensure([], () => r(require('@/components/my/wageSlip')), 'com-wage-slip'),
  Help: r => require.ensure([], () => r(require('@/components/my/help')), 'com-help'),
  HelpDetail: r => require.ensure([], () => r(require('@/components/my/helpDetail')), 'com-help-detail'),
  Information: r => require.ensure([], () => r(require('@/components/my/information')), 'com-information'),
  MyContract: r => require.ensure([], () => r(require('@/components/econtract/myContract')), 'com-my-contract'),
  GainContract: r => require.ensure([], () => r(require('@/components/econtract/gainContract')), 'com-gain-contract'),
  WriteContract: r => require.ensure([], () => r(require('@/components/econtract/writeContract')), 'com-write-contract'),
  NextStep: r => require.ensure([], () => r(require('@/components/econtract/nextStep')), 'com-next-step-contract'),
  Identification: r => require.ensure([], () => r(require('@/components/econtract/identification')), 'com-identification-contract'),
  Viewpdf: r => require.ensure([], () => r(require('@/components/viewpdf/Index')), 'com-viewpdf'),
  PersonalSign: r => require.ensure([], () => r(require('@/components/personalsign/Index')), 'com-personalsign'),
  Pdf: r => require.ensure([], () => r(require('@/components/pdf/Index')), 'com-pdf'),
  ApplyNew: r => require.ensure([], () => r(require('@/components/advanceNew/Apply')), 'com-apply-new'),
  ApplySureNew: r => require.ensure([], () => r(require('@/components/advanceNew/ApplySure')), 'com-sure-new'),
  ApplySuccessNew: r => require.ensure([], () => r(require('@/components/advanceNew/ApplySuccess')), 'com-success-new'),
  ValidatePhoto: r => require.ensure([], () => r(require('@/components/daily/validatePhoto')), 'com-validate-photo'),
  Setting: r => require.ensure([], () => r(require('@/components/my/setting')), 'com-setting'),
  Consult: r => require.ensure([], () => r(require('@/components/consult/index')), 'com-consult-index'),
  ConsultSuccess: r => require.ensure([], () => r(require('@/components/consult/success')), 'com-consult-success'),
  MyAccount: r => require.ensure([], () => r(require('@/components/my/myAccount')), 'com-my-myAccount'),
  PersonalInfo: r => require.ensure([], () => r(require('@/components/my/personalInfo')), 'com-my-personalInfo'),
  IdentificationIdcard: r => require.ensure([], () => r(require('@/components/my/identification')), 'com-my-identification'),
  Face: r => require.ensure([], () => r(require('@/components/my/face')), 'com-my-face'),
  Transfer: r => require.ensure([], () => r(require('@/components/transfer/transferPage')), 'com-transfer-transferPage'),
  AdvanceV2Index: r => require.ensure([], () => r(require('@/components/advanceV2/index')), 'com-advanceV2-index'),
  AdvanceV2Success: r => require.ensure([], () => r(require('@/components/advanceV2/advanceSuccess')), 'com-advanceV2-advanceSuccess'),
  AdvanceV2Sure: r => require.ensure([], () => r(require('@/components/advanceV2/advanceSure')), 'com-advanceV2-advanceSure'),
  AdvanceV2Record: r => require.ensure([], () => r(require('@/components/advanceV2/advanceRecord')), 'com-advanceV2-advanceRecord'),
  OpenId: r => require.ensure([], () => r(require('@/components/my/openId')), 'com-my-openId'),
};
//解决编程式路由往同一地址跳转时会报错的情况
const originalPush = Router.prototype.push;
const originalReplace = Router.prototype.replace;
//push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};
//replace
Router.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch(err => err);
};

export default new Router({
  routes: [
    {
      path: "/",
      name: "launch",
      component: myComponents.Launch
    },
    {
      path: "/home",
      name: "home",
      redirect: "/account",
      component: myComponents.Home,
      children: [
        {
          path: "/account",
          name: "account",
          component: myComponents.Account,
          beforeEnter(to, from, next) {
            document.title = "收入";
            next();
          },
          meta: {
            keepAlive: true //此组件不需要被缓存
          }
        },
        {
          path: "/advance",
          name: "advance",
          component: myComponents.Advance,
          beforeEnter(to, from, next) {
            document.title = "预支";
            next();
          },
          meta: {
            keepAlive: true //此组件不需要被缓存
          }
        },
        {
          path: "/advanceV2/index",
          name: "AdvanceV2Index",
          component: myComponents.AdvanceV2Index,
          beforeEnter(to, from, next) {
            document.title = "预支工资";
            next();
          },
          meta: {
            keepAlive: false //此组件需要被缓存
          }
        },
        {
          path: "/daily",
          name: "daily",
          component: myComponents.Daily,
          beforeEnter(to, from, next) {
            document.title = "打卡";
            next();
          },
          meta: {
            keepAlive: false
          }
        },
        {
          path: "/my",
          name: "my",
          component: myComponents.My,
          beforeEnter(to, from, next) {
            document.title = "我的";
            next();
          },
          meta: {
            keepAlive: true //此组件不需要被缓存
          }
        }
      ]
    },
    {
      path: "/cash",
      name: "cash",
      component: myComponents.Cash,
      beforeEnter(to, from, next) {
        document.title = "领取";
        next();
      },
      meta: {
        keepAlive: true //此组件不需要被缓存
      }
    },
    {
      path: "/supplementCard",
      name: "SupplementCard",
      component: myComponents.SupplementCard,
      beforeEnter(to, from, next) {
        document.title = "补充银行卡信息";
        next();
      },
      meta: {
        keepAlive: false
      }
    },
    {
      path: "/cashAlipay",
      name: "CashAlipay",
      component: myComponents.CashAlipay,
      beforeEnter(to, from, next) {
        document.title = "提现免费";
        next();
      },
      meta: {
        keepAlive: false
      }
    },
    {
      path: "/cashForShare",
      name: "cashForShare",
      component: myComponents.CashForShare,
      beforeEnter(to, from, next) {
        document.title = "领取";
        next();
      },
      meta: {
        keepAlive: true //此组件不需要被缓存
      }
    },
    {
      path: "/cashForShare",
      name: "cash",
      component: myComponents.CashForShare,
      beforeEnter(to, from, next) {
        document.title = "领取";
        next();
      },
      meta: {
        keepAlive: true //此组件不需要被缓存
      }
    },
    {
      path: "/cashForRedPack",
      name: "cash",
      component: myComponents.CashForRedPack,
      beforeEnter(to, from, next) {
        document.title = "领取";
        next();
      },
      meta: {
        keepAlive: true //此组件不需要被缓存
      }
    },
    {
      path: "/cashAll",
      name: "cashAll",
      component: myComponents.CashAll,
      beforeEnter(to, from, next) {
        document.title = "领取";
        next();
      },
      meta: {
        keepAlive: true //此组件不需要被缓存
      }
    },
    {
      path: "/redPackPage/:status",
      name: "redpackpage",
      component: myComponents.RedPackPage,
      beforeEnter(to, from, next) {
        document.title = "领入职红包";
        next();
      },
      meta: {
        keepAlive: true //此组件不需要被缓存
      }
    },
    {
      path: "/redPackPage/",
      name: "redpackpage",
      component: myComponents.RedPackPage,
      beforeEnter(to, from, next) {
        document.title = "领入职红包";
        next();
      },
      meta: {
        keepAlive: true //此组件不需要被缓存
      }
    },
    {
      path: "/agreementList",
      name: "agreementList",
      component: myComponents.AgreementList,
      beforeEnter(to, from, next) {
        document.title = "协议";
        next();
      },
      meta: {
        keepAlive: true //此组件不需要被缓存
      }
    },
    {
      path: "/bindAlipay",
      name: "bindAlipay",
      component: myComponents.BindAlipay,
      beforeEnter(to, from, next) {
        document.title = "绑定支付宝";
        next();
      },
      meta: {
        keepAlive: true //此组件不需要被缓存
      }
    },
    {
      path: "/detailed",
      name: "detailed",
      component: myComponents.Detailed,
      beforeEnter(to, from, next) {
        document.title = "收支明细";
        next();
      },
      meta: {
        keepAlive: true //此组件不需要被缓存
      }
    },
    {
      path: "/accountDetails",
      name: "accountDetails",
      component: myComponents.AccountDetails,
      beforeEnter(to, from, next) {
        document.title = "收支明细";
        next();
      },
      meta: {
        keepAlive: true //此组件不需要被缓存
      }
    },
    {
      path: "/card",
      name: "card",
      component: myComponents.Card,
      beforeEnter(to, from, next) {
        document.title = "我的银行卡";
        next();
      },
      meta: {
        keepAlive: true //此组件不需要被缓存
      }
    },
    {
      path: "/cardDetail",
      name: "cardDetail",
      component: myComponents.CardDetail,
      beforeEnter(to, from, next) {
        document.title = "银行卡管理";
        next();
      },
      meta: {
        keepAlive: true //此组件不需要被缓存
      }
    },
    {
      path: "/bindCard",
      name: "bindCard",
      component: myComponents.BindCard,
      beforeEnter(to, from, next) {
        document.title = "我的银行卡";
        next();
      },
      meta: {
        keepAlive: true //此组件不需要被缓存
      }
    },
    {
      path: "/serve",
      name: "serve",
      component: myComponents.Serve,
      beforeEnter(to, from, next) {
        document.title = "联系客服";
        next();
      },
      meta: {
        keepAlive: true //此组件不需要被缓存
      }
    },

    // {
    //   path: "/wageSlip",
    //   name: "wageSlip",
    //   component: myComponents.WageSlip,
    //   beforeEnter(to, from, next) {
    //     document.title = "我的工资单";
    //     next();
    //   },
    //   meta: {
    //     keepAlive: false //此组件不需要被缓存
    //   }
    // },
    {
      path: "/apply/:acount",
      name: "apply",
      component: myComponents.Apply,
      beforeEnter(to, from, next) {
        document.title = "预支";
        next();
      },
      meta: {
        keepAlive: true //此组件不需要被缓存
      }
    },
    {
      path: "/applyNew/:acount",
      name: "applyNew",
      component: myComponents.ApplyNew,
      beforeEnter(to, from, next) {
        document.title = "预支";
        next();
      },
      meta: {
        keepAlive: true //此组件不需要被缓存
      }
    },
    {
      path: "/advanceRecord",
      name: "advanceRecord",
      component: myComponents.AdvanceRecord,
      beforeEnter(to, from, next) {
        document.title = "预支记录";
        next();
      },
      meta: {
        keepAlive: true //此组件不需要被缓存
      }
    },
    {
      path: "/sure",
      name: "sure",
      component: myComponents.ApplySure,
      beforeEnter(to, from, next) {
        document.title = "预支";
        next();
      },
      meta: {
        keepAlive: true //此组件不需要被缓存
      }
    },
    {
      path: "/sureNew",
      name: "sureNew",
      component: myComponents.ApplySureNew,
      beforeEnter(to, from, next) {
        document.title = "预支";
        next();
      },
      meta: {
        keepAlive: true //此组件不需要被缓存
      }
    },
    {
      path: "/applySuccess",
      name: "applySuccess",
      component: myComponents.ApplySuccess,
      beforeEnter(to, from, next) {
        document.title = "预支";
        next();
      },
      meta: {
        keepAlive: true //此组件不需要被缓存
      }
    },
    {
      path: "/applySuccessNew",
      name: "applySuccessNew",
      component: myComponents.ApplySuccessNew,
      beforeEnter(to, from, next) {
        document.title = "预支";
        next();
      },
      meta: {
        keepAlive: true //此组件不需要被缓存
      }
    },
    {
      path: "/login",
      name: "login",
      component: myComponents.Login,
      beforeEnter(to, from, next) {
        document.title = "加载中";
        next();
      },
      meta: {
        keepAlive: true //此组件不需要被缓存
      }
    },
    {
      path: "/setting",
      name: "setting",
      component: myComponents.Setting,
      beforeEnter(to, from, next) {
        document.title = "设置";
        next();
      },
      meta: {
        keepAlive: true //此组件不需要被缓存
      }
    },
    {
      path: "/consultSuccess",
      name: "consultSuccess",
      component: myComponents.ConsultSuccess,
      beforeEnter(to, from, next) {
        document.title = "";
        next();
      },
      meta: {
        keepAlive: true //此组件不需要被缓存
      }
    },
    {
      path: "/consult",
      name: "consult",
      component: myComponents.Consult,
      beforeEnter(to, from, next) {
        document.title = "安心云人事提供系统支持";
        next();
      },
      meta: {
        keepAlive: true //此组件不需要被缓存
      }
    },
    {
      path: "/vertify",
      name: "vertify",
      component: myComponents.LoginVertify,
      beforeEnter(to, from, next) {
        document.title = "登录";
        next();
      },
      meta: {
        keepAlive: true //此组件不需要被缓存
      }
    },
    {
      path: "/about",
      name: "about",
      component: myComponents.About,
      beforeEnter(to, from, next) {
        document.title = "关于我们";
        next();
      },
      meta: {
        keepAlive: true //此组件不需要被缓存
      }
    },
    {
      path: "/help",
      name: "help",
      component: myComponents.Help,
      beforeEnter(to, from, next) {
        document.title = "帮助中心";
        next();
      },
      meta: {
        keepAlive: true //此组件不需要被缓存
      }
    },
    {
      path: "/information",
      name: "information",
      component: myComponents.Information,
      beforeEnter(to, from, next) {
        document.title = "信息凭证";
        next();
      },
      meta: {
        keepAlive: false //此组件不需要被缓存
      }
    },
    {
      path: "/helpDetail/:type",
      name: "helpDetail",
      component: myComponents.HelpDetail,
      beforeEnter(to, from, next) {
        document.title = "帮助中心";
        next();
      },
      meta: {
        keepAlive: true //此组件不需要被缓存
      }
    },
    {
      path: "/bindAll",
      name: "bindAll",
      component: myComponents.BindAll,
      beforeEnter(to, from, next) {
        document.title = "绑定提现渠道";
        next();
      },
      meta: {
        keepAlive: true //此组件不需要被缓存
      }
    },
    {
      path: "/slowBank",
      name: "slowBank",
      component: myComponents.SlowBank,
      beforeEnter(to, from, next) {
        document.title = "温馨提示";
        next();
      },
      meta: {
        keepAlive: true //此组件不需要被缓存
      }
    },
    {
      path: "/dailyRecord",
      name: "dailyRecord",
      component: myComponents.DailyRecord,
      beforeEnter(to, from, next) {
        document.title = "打卡";
        next();
      },
      meta: {
        keepAlive: true //此组件不需要被缓存
      }
    },
    {
      path: "/validatePhoto",
      name: "validatePhoto",
      component: myComponents.ValidatePhoto,
      beforeEnter(to, from, next) {
        document.title = "提交信息";
        next();
      },
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/dailyCalendar",
      name: "dailyCalendar",
      component: myComponents.DailyCalendar,
      beforeEnter(to, from, next) {
        document.title = "记录";
        next();
      },
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/DailyFail",
      name: "DailyFail",
      component: myComponents.DailyFail,
      beforeEnter(to, from, next) {
        document.title = "补卡";
        next();
      },
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/myContract",
      name: "myContract",
      component: myComponents.MyContract,
      beforeEnter(to, from, next) {
        if (to.path === "/myContract" || from.path === "/writeContract") {
          store.commit("SET_CASE", false);
          sessionStorage.removeItem("list");
        } else {
          store.commit("SET_CASE", false);
          sessionStorage.removeItem("list");
        }
        document.title = "我的合同";
        next();
      },
      meta: {
        keepAlive: false //此组件不需要被缓存
      }
    },
    {
      path: "/gainContract",
      name: "gainContract",
      component: myComponents.GainContract,
      beforeEnter(to, from, next) {
        document.title = "获取合同";
        next();
      },
      meta: {
        keepAlive: false //此组件不需要被缓存
      }
    },
    {
      path: "/writeContract",
      name: "writeContract",
      component: myComponents.WriteContract,
      beforeEnter(to, from, next) {
        if (from.path === "/myContract" || to.path === "/writeContract") {
          store.commit("SET_CASE", true);
        } else {
          store.commit("SET_CASE", false);
        }
        document.title = "电子合同";
        next();
      }
    },
    {
      path: "/nextStep",
      name: "nextStep",
      component: myComponents.NextStep,
      beforeEnter(to, from, next) {
        document.title = "电子合同";
        next();
      },
      meta: {
        keepAlive: false //此组件不需要被缓存
      }
    },
    {
      path: "/identification",
      name: "identification",
      component: myComponents.Identification,
      beforeEnter(to, from, next) {
        document.title = "认证身份";
        next();
      },
      meta: {
        keepAlive: false //此组件不需要被缓存
      }
    },
    {
      path: "/viewpdf",
      name: "viewpdf",
      component: myComponents.Viewpdf,
      beforeEnter(to, from, next) {
        document.title = "查看合同";
        next();
      }
    },
    {
      path: "/personalSign",
      name: "personalsign",
      component: myComponents.PersonalSign,
      beforeEnter(to, from, next) {
        document.title = "签署中";
        next();
      },
      meta: {
        keepAlive: false //此组件不需要被缓存
      }
    },
    {
      path: "/pdf",
      name: "pdf",
      component: myComponents.Pdf,
      beforeEnter(to, from, next) {
        document.title = "签署中";
        next();
      },
      meta: {
        keepAlive: false //此组件不需要被缓存
      }
    },
    {
      path: "/myAccount",
      name: "myAccount",
      component: myComponents.MyAccount,
      beforeEnter(to, from, next) {
        document.title = "我的账户";
        next();
      },
      meta: {
        keepAlive: true //此组件不需要被缓存
      }
    },
    {
      path: "/identificationCard",
      name: "identificationCard",
      component: myComponents.IdentificationIdcard,
      beforeEnter(to, from, next) {
        document.title = "实名认证";
        next();
      },
      meta: {
        keepAlive: false //此组件不需要被缓存
      }
    },
    {
      path: "/face",
      name: "face",
      component: myComponents.Face,
      beforeEnter(to, from, next) {
        document.title = "人脸识别";
        next();
      },
      meta: {
        keepAlive: false //此组件不需要被缓存
      }
    },
    {
      path: "/personalInfo",
      name: "personalInfo",
      component: myComponents.PersonalInfo,
      beforeEnter(to, from, next) {
        document.title = "我的信息";
        next();
      },
      meta: {
        keepAlive: false //此组件不需要被缓存
      }
    },
    {
      path: "/transferPage",
      name: "transferPage",
      component: myComponents.Transfer,
      beforeEnter(to, from, next) {
        document.title = "";
        next();
      },
      meta: {
        keepAlive: false //此组件不需要被缓存
      }
    },
    {
      path: "/advanceV2/index",
      name: "AdvanceV2Index",
      component: myComponents.AdvanceV2Index,
      beforeEnter(to, from, next) {
        document.title = "预支工资";
        next();
      },
      meta: {
        keepAlive: false //此组件需要被缓存
      }
    },
    {
      path: "/advanceV2/advanceSuccess",
      name: "AdvanceV2Success",
      component: myComponents.AdvanceV2Success,
      beforeEnter(to, from, next) {
        document.title = "预支成功";
        next();
      },
      meta: {
        keepAlive: true //此组件需要被缓存
      }
    },
    {
      path: "/advanceV2/advanceRecord",
      name: "AdvanceV2Record",
      component: myComponents.AdvanceV2Record,
      beforeEnter(to, from, next) {
        document.title = "预支记录";
        next();
      },
      meta: {
        keepAlive: false //此组件需要被缓存
      }
    },
    {
      path: "/advanceV2/advanceSure/:applyBizNo?",
      name: "AdvanceV2Sure",
      component: myComponents.AdvanceV2Sure,
      beforeEnter(to, from, next) {
        document.title = "预支申请";
        next();
      },
      meta: {
        keepAlive: true //此组件需要被缓存
      }
    },
    {
      path: "/my/openId",
      name: "OpenId",
      component: myComponents.OpenId,
      beforeEnter(to, from, next) {
        document.title = "查看openId";
        next();
      },
      meta: {
        keepAlive: true //此组件需要被缓存
      }
    },
    {
      path: "/test",
      name: "test",
      component: () => import("@/components/test"),
      beforeEnter(to, from, next) {
        document.title = "测试";
        next();
      },
      meta: {
        keepAlive: false //此组件不需要被缓存
      }
    },
    ...routes,
    {
      path: "*",
      redirect: "/account"
    }
  ]
});
